import { render, staticRenderFns } from "./V999Appinfo.vue?vue&type=template&id=5747f0b7"
import script from "./V999Appinfo.vue?vue&type=script&lang=js"
export * from "./V999Appinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../Documents/GitHub/ogsmyadmin-1/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports